import { Box, Container } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import VideoPlayer from "../videoPlayer";
import "./videoSection.scss";

const VideoSection = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      margin="6rem 0"
      sx={{
        display: "flex",
        flexWrap: { lg: "nowrap", xs: "wrap" },
        justifyContent: { lg: "space-between", xs: "center" },
      }}
    >
      <Box className="description-block">
        <p
          dangerouslySetInnerHTML={{
            __html: t("why-do-you-need-generational-consulting"),
          }}
        ></p>
      </Box>
      <div className="video-block">
        <VideoPlayer />
      </div>
    </Box>
  );
};

export default VideoSection;
